import React, { useState, useEffect } from "react";
import { Button, Row, Col, Tooltip } from "reactstrap";
import Combobox from "../Combobox";
import { Field } from "../Field";
import Requeriments from "./Requeriments";
import { UserType, instructionWrittenTypes, instructionWebTypes } from "../../../../../utils/Helper";
import CircularProgress from "../../../../CircularProgress/CircularProgress";
import style from "./Account.module.scss";

const Instruction = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [showWrittenType, setShowWrittenType] = useState(false);
  const [showWebType, setShowWebType] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  useEffect(() => {
    props.getParameterValue &&
      props.getParameterValue({ ParameterName: "showWrittenInstructionTypes" }, (response) => {
        if (response && response.SdtParametersData.ParameterNumericValue == 1) {
          setShowWrittenType(true);
        }
      });
    props.getParameterValue &&
      props.getParameterValue({ ParameterName: "showWebInstructionTypes" }, (response) => {
        if (response && response.SdtParametersData.ParameterNumericValue == 1) {
          setShowWebType(true);
        }
      });
  }, []);

  const items = (() => {
    if (props.items == null || props.items.length == 0) {
      if (props.value != null) {
        return [
          {
            id: props.value,
            description: props.value,
          },
        ];
      }
      return [];
    }
    return props.items;
  })();

  const value = props.items != null ? props.value : items.length ? props.value : -1;
  const valueInsType = props.InstructionType ? props.InstructionType : null;

  const { error } = props;
  const {
    setAttachment,
    downloadAttachment,
    hasAttachment,
    attachmentDisabled,
    onResendAuth,
    orderPdf,
    orderId,
    accountId,
    onChangeOrder,
    userType,
    canResend,
    sendingMail,
    hasFile,
    isProp,
    InstructionType,
    getParameterValue,
    ...restProps
  } = props;

  const setUploaded = (props) => {
    if (props.hasAttachment && props.hasAttachment.uploadPending) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <React.Fragment>
      <Row>
        {!isProp && (
          <Col>
            <Field label="Instruction" error={error}>
              <Combobox
                emptyLabel="Instruction"
                {...restProps}
                disabled={props.disabled || setUploaded(props)}
                items={items}
                invalid={!!error}
                value={value}
                onChange={(v) => props.onChange({ type: "instruction", value: v })}
              />
            </Field>
            {((showWrittenType && value == "Written") || (showWebType && value == "Web")) && valueInsType && (
              <Field label="Instruction type">
                <Combobox
                  emptyLabel="Instruction type"
                  {...restProps}
                  disabled={props.disabled || setUploaded(props)}
                  items={value == "Written" ? instructionWrittenTypes : instructionWebTypes}
                  value={valueInsType}
                  onChange={(v) => props.onChange({ type: "instructionType", value: v })}
                />
              </Field>
            )}
          </Col>
        )}
        {canResend && (
          <Col style={{ flexGrow: 0, margin: "auto" }}>
            {sendingMail ? (
              <CircularProgress sm />
            ) : (
              <React.Fragment>
                <Button
                  id="tooltipResend"
                  color="btn-outline-primary btn-sm"
                  onClick={() => onResendAuth(orderId, accountId)}
                >
                  <i className="fa fa-send" />
                </Button>
                <Tooltip placement="top" target="tooltipResend" isOpen={tooltipOpen} toggle={toggleTooltip}>
                  Resend Authorization Mail
                </Tooltip>
              </React.Fragment>
            )}
          </Col>
        )}
      </Row>
      {(!attachmentDisabled || userType === UserType.MiddleOffice) && (value == "Written" || isProp) ? (
        <Requeriments
          setAttachment={setAttachment}
          downloadAttachment={downloadAttachment}
          orderPdf={orderPdf}
          orderId={orderId}
          onChangeOrder={(e) => onChangeOrder({ ...e, Instruction: restProps.value })}
          readonly={props.disabled && !userType === UserType.MiddleOffice}
          hasAttachment={hasAttachment}
          hasFile={hasFile}
          accountId={accountId}
        />
      ) : (
        <React.Fragment>
          {orderId && orderPdf && (
            <div className={style.requeriments}>
              <div className={style.line}>
                <span>Download order as pdf</span>
                <button
                  className={`mr-1 btn btn-light ${style.pdf}`}
                  tooltip="Download PDF"
                  tooltip-position="bottom"
                  onClick={() => orderPdf({ orderId })}
                >
                  <img />
                </button>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Instruction;
